module.exports = __webpack_public_path__ + "static/media/iconmonstr-facebook-1.005a8fc2.svg";